import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "@luna-restaurant/i18n";
import { FontAwesomeKitIcon, useCustomTheme } from "@luna-restaurant/ui";
const getDietaryLabelStyle = (label, colors) => {
    switch (label) {
        case "vegetarian":
            return {
                backgroundColor: colors.palette.lime40,
                color: colors.background,
            };
        case "fish":
            return {
                backgroundColor: colors.palette.spinach30,
                color: colors.background,
            };
        case "meat":
            return {
                backgroundColor: colors.palette.carrot40,
                color: colors.background,
            };
        default:
            return {
                backgroundColor: colors.muted,
                color: colors.background,
            };
    }
};
const LabelIcon = ({ label, color, size, }) => {
    switch (label) {
        case "vegetarian":
            return <FontAwesomeKitIcon name="leaf-heart" size={size} color={color}/>;
        case "fish":
            return <FontAwesomeKitIcon name="fish" size={size} color={color}/>;
        case "meat":
            return <FontAwesomeKitIcon name="steak" size={size} color={color}/>;
    }
};
const getDietaryLabelText = (label) => {
    switch (label) {
        case "vegetarian":
            return "menuCard.labels.vegetarian";
        case "fish":
            return "menuCard.labels.fish";
        case "meat":
            return "menuCard.labels.meat";
    }
};
export const MenuLabel = ({ label }) => {
    const { colors, fonts } = useCustomTheme();
    const labelStyle = getDietaryLabelStyle(label, colors);
    const { t } = useTranslation();
    return (<View style={[styles.labelContainer, labelStyle]}>
      <LabelIcon label={label} size={14} color={labelStyle.color}/>
      <Text style={[
            styles.labelText,
            { ...fonts.semiBold, color: labelStyle.color },
        ]}>
        {t(getDietaryLabelText(label)).toUpperCase()}
      </Text>
    </View>);
};
const styles = StyleSheet.create({
    labelContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
        paddingHorizontal: 4,
        paddingVertical: 2,
        borderRadius: 2,
        minWidth: 36,
        justifyContent: "center",
        height: 18,
    },
    labelText: {
        fontSize: 12,
        letterSpacing: 1.02,
        lineHeight: 14.4,
    },
});
//# sourceMappingURL=MenuLabel.js.map